// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"a6c78eb5","773":"f1cf11cc","929":"82ea6198"}[chunkId] + ".chunk.js";
};